import { motion } from "framer-motion";

const CITIES = [
  { name: "NASHIK", note: "The first whistle. Garma-garam incoming.", rotate: "-rotate-2" },
  { name: "PUNE", note: "Oxford of the East, meet the footlong of the West.", rotate: "rotate-2" },
];

export const Stores = () => (
  <section id="stores" data-testid="stores-section" className="scroll-mt-16 border-y-4 border-kadak bg-mirchi py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 text-center">
      <p className="font-bungee text-xs tracking-[0.35em] text-taxi sm:text-sm">FLAGSHIP KHOKAS</p>
      <h2 className="mt-4 font-shrikhand text-4xl text-pav sm:text-5xl lg:text-6xl" style={{ textShadow: "4px 4px 0 #221A10" }}>
        Opening soon. Line mein aao.
      </h2>
      <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-2">
        {CITIES.map((c, i) => (
          <motion.div
            key={c.name}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ type: "spring", stiffness: 80, damping: 14, delay: i * 0.15 }}
            className={`relative rounded-3xl border-4 border-kadak bg-kadak p-8 sticker-shadow-taxi ${c.rotate}`}
          >
            <div className="flex justify-center gap-1.5">
              {Array.from({ length: 9 }).map((_, b) => (
                <span key={b} className={`h-2.5 w-2.5 rounded-full ${b % 2 ? "bg-taxi" : "bg-pav"}`} />
              ))}
            </div>
            <p className="mt-6 font-shrikhand text-5xl text-taxi sm:text-6xl" style={{ textShadow: "3px 3px 0 #E03A2F" }}>
              {c.name}
            </p>
            <span className="mt-5 inline-block -rotate-3 rounded-lg border-4 border-gulabi px-5 py-2 font-bungee text-sm tracking-widest text-gulabi">
              OPENING SOON
            </span>
            <p className="mt-5 text-sm text-pav/70">{c.note}</p>
            <div className="tape-checker mt-6 h-5 w-full rounded-md" />
          </motion.div>
        ))}
      </div>
      <p className="mt-12 inline-block rounded-full border-4 border-kadak bg-pav px-6 py-2 font-bungee text-xs tracking-widest text-kadak sticker-shadow sm:text-sm">
        KHAALI PET MAT JAO.
      </p>
    </div>
  </section>
);
